// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Fuhrparkeintrag, FuhrparkeintragDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateFuhrparkeintrag(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  requestBody: FuhrparkeintragDaten
) => Promise<Fuhrparkeintrag> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, requestBody) =>
      (await getAPI()).fuhrparkeintraege.updateFuhrparkeintrag({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        requestBody,
      }),
    [getAPI]
  );
}
